import { FC } from 'react'
import { Row, Col, Text, Button, Icon } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
export const TileBlock: FC<any> = ({ guide, width = 'half' }) => {
  const { routerPush } = useRouterPush()
  const halfBlock = () => (
    <S.TileBlockWrapper>
      <Row>
        {guide.map(
          ({
            guide_label,
            guide_heading,
            guide_description,
            guide_image,
            guide_link_label,
            guide_link_url,
            guide_type
          }) => (
            <Col xs='12' hd='6' className='guide-col' key={`key_${guide_type}`}>
              <S.TileBlock type={guide_type}>
                <S.TileBlockContent>
                  <Text
                    as='p'
                    size='baseroot'
                    className='tile-block-label'
                    family='text'
                    weight='normal'
                    margin='0 0 0 0'
                    itemProp='name'
                  >
                    {guide_label}
                  </Text>
                  <Text
                    as='h2'
                    size='h5max'
                    className='tile-block-header'
                    family='text'
                    weight='semiBlack'
                    margin='0 0 0 0'
                    itemProp='name'
                  >
                    {guide_heading}
                  </Text>
                  <Text
                    as='p'
                    size='xs'
                    className='tile-block-text'
                    family='text'
                    weight='normal'
                    margin='0 0 0 0'
                    itemProp='name'
                  >
                    {guide_description}
                  </Text>
                </S.TileBlockContent>

                <S.ImgSet halfSet>
                  <img src={guide_image.url}></img>
                </S.ImgSet>
                <S.ButtonSet>
                  <Button kind='warning' onClick={() => routerPush(guide_link_url)} isPill size='small'>
                    {guide_link_label}
                    <Icon name='arrow-right' />
                  </Button>
                </S.ButtonSet>
              </S.TileBlock>
            </Col>
          )
        )}
      </Row>
    </S.TileBlockWrapper>
  )
  const fullBlock = () => (
    <S.TileBlockWrapper>
      {guide.map(
        ({
          guide_label,
          guide_heading,
          guide_description,
          guide_image,
          guide_link_label,
          guide_link_url,
          guide_type,
          smart_text,
          smart_section_url,
          price_smart,
          pro_section_url,
          unit_smart,
          description_smart,
          pro_text,
          price_pro,
          unit_vat,
          description_pro
        }) => (
          <Row key={`key_${guide_type}`}>
            <Col xs='12' hd='12' className='guide-col'>
              <S.TileBlockFull type={'Light Blue'}>
                <Row isFull>
                  <Col xs='12' hd='7' className='tile-block-in' key={`key_${guide_type}`} noGutter>
                    <S.TileBlockContentFull>
                      <Text
                        as='p'
                        size='baseroot'
                        className='tile-block-label'
                        family='text'
                        weight='normal'
                        margin='0 0 0 0'
                        itemProp='name'
                      >
                        {guide_label}
                      </Text>
                      <Text
                        as='h2'
                        size='h5max'
                        className='tile-block-header'
                        family='text'
                        weight='semiBlack'
                        margin='0 0 0 0'
                        itemProp='name'
                      >
                        {guide_heading}
                      </Text>
                      <Text
                        as='p'
                        size='xs'
                        className='tile-block-text'
                        family='text'
                        weight='normal'
                        margin='0 0 0 0'
                        itemProp='name'
                      >
                        {guide_description}
                      </Text>
                    </S.TileBlockContentFull>
                    <S.ImgSet className='tilefullblock-imgset'>
                      <img src={guide_image.url}></img>
                    </S.ImgSet>
                    <S.ButtonSet></S.ButtonSet>
                  </Col>
                  <Col xs='12' hd='5' className='guide-price-part' key={`key_${guide_type}`} noGutter>
                    <Row isFull>
                      <Col xs='12' xl='6'>
                        <Button
                          kind='dark'
                          onClick={() => routerPush(smart_section_url)}
                          isPill
                          isBlock
                          size='small'
                          style={{ marginBottom: '0.5rem' }}
                        >
                          <S.ButtonWrap>
                            <S.Part>{smart_text}</S.Part>
                            <S.Part>
                              {price_smart}
                              {unit_smart}
                              <Icon name='arrow-right' />
                            </S.Part>
                          </S.ButtonWrap>
                        </Button>
                        <Text as='p'>{description_smart}</Text>
                      </Col>
                      <Col xs='12' xl='6'>
                        <Button
                          kind='goldenBrown'
                          onClick={() => routerPush(pro_section_url)}
                          isPill
                          isBlock
                          size='small'
                          style={{ marginBottom: '0.5rem' }}
                        >
                          <S.ButtonWrap>
                            <S.Part>{pro_text}</S.Part>
                            <S.Part>
                              {price_pro}
                              {unit_vat}
                              <Icon name='arrow-right' />
                            </S.Part>
                          </S.ButtonWrap>
                        </Button>
                        <Text as='p'>{description_pro}</Text>
                      </Col>
                    </Row>
                    <Row isFull>
                      <Col>
                        <Button
                          kind='warning'
                          onClick={() => routerPush(guide_link_url)}
                          isPill
                          size='small'
                          isBlock
                          style={{ justifyContent: 'flex-start', paddingLeft: '1rem', paddingRight: '1rem' }}
                        >
                          {guide_link_label}

                          <Icon name='arrow-right' />
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </S.TileBlockFull>
            </Col>
          </Row>
        )
      )}
    </S.TileBlockWrapper>
  )

  if (width === 'half') {
    return <>{halfBlock()}</>
  } else {
    return <>{fullBlock()}</>
  }
}
